import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { RECOIL_PERSIST_LOGIN_KEY } from "../sharedStrings";

const { persistAtom } = recoilPersist({
  key: RECOIL_PERSIST_LOGIN_KEY,
});

export const userIdInputState = atom<string | null>({
  key: `userIdInput`,
  default: null,
  effects_UNSTABLE: [persistAtom],
});
